export const name = 'Alerts';

import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

/**
 * Documentazione:
 * https://www.npmjs.com/package/vue-toast-notification
 */

export function sendMessage(message, options) {

  /**
   * options.type can be:
   * success, info, warning, error, default
   */
  const type = options.type ?? 'default'
  const duration = options.duration ?? 6000
  const $toast = useToast();

  let instance = $toast.open({
    message: message,
    type: type,
    duration: duration
  });

}

export function info(message, options) {
  if (!options){
    options = {}
  }
  options.type = 'info'
  sendMessage(message, options)
}

export function success(message, options) {
  if (!options){
    options = {}
  }
  options.type = 'success'
  sendMessage(message, options)
}

export function warning(message, options) {
  if (!options){
    options = {}
  }
  options.type = 'warning'
  sendMessage(message, options)
}

export function error(message, options) {
  if (!options){
    options = {}
  }
  const errors = options.errors
  let fullMessage = message
  if (errors){
    fullMessage += "\n"
    for (let fieldName in errors){
      fullMessage += fieldName + ": " + errors[fieldName] + "\n"
    }
  }
  options.type = 'error'
  sendMessage(fullMessage, options)
}
